import { AccessAdminMessagesData, SharedState } from 'app/types-shared';

export const getAdminMessageAccess =
  (sharedState: SharedState): AccessAdminMessagesData =>
    sharedState && sharedState.access && sharedState.access.adminPanel &&
    sharedState.access.adminPanel.message || {
      read: false,
      edit: false,
      delete: false
    };
